import { Popconfirm, Row, Space, Table } from "antd";
import React, { useEffect, useState } from "react";
import { withRouter } from "../../../../../../utils/tms-with-router/tms-with-router";
import tmsRouteMap from "../../../../../../constants/tms-route.map";
import {
  FdrInstitutionSelect,
  SortTypeAndBy,
} from "../../../../../../components/tms-customs/rents-and-leases/index";

import { DeleteOutlined } from "@ant-design/icons";
import { createFdrStates } from "../../../../../../constants/states-data.data";
import useFdrStore from "../../../../../../zustand/fdr.store";

const TmsSmFdrAccountList = ({ router }) => {
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(10);
  const [sortType, setSortType] = useState("ASC");
  const [sortBy, setSortBy] = useState("createdAt");
  const [update, setUpdate] = useState("");

  const {
    accountCategoryData,
    selectedInstitution,
    loading,
    clearStates,
    fetchInstitutionList,
    deleteLoading,
    fetchCreatedAccountCategory,
    deleteCreatedAccountCategory,
  } = useFdrStore();

  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
    if (sorter.field === "createdAt") {
      if (sorter.order === "ascend") {
        setSortType("ASC");
      } else if (sorter.order === "descend") {
        setSortType("DESC");
      }
    }
  };
  useEffect(() => {
    return () => {
      clearStates(createFdrStates, []);
    };
  }, []);

  useEffect(() => {
    (router.location.pathname === tmsRouteMap.sm_ral_fdr_account_creation ||
      router.location.pathname === tmsRouteMap.sm_ral_fdr) &&
      fetchInstitutionList(1, 200, "ASC", "createdAt", router);
  }, [router.location.pathname]);

  useEffect(() => {
    if (selectedInstitution && selectedInstitution !== "")
      fetchCreatedAccountCategory(1, 200, "ASC", "createdAt", router);
  }, [
    sortBy,
    tableCurrentPage,
    tablePageSize,
    sortType,
    selectedInstitution,
    update,
  ]);

  // const handlePrint = useReactToPrint({
  //   content: () => refContainer.current,
  //   copyStyles: true,
  //   bodyClass: "tms-lease-container",
  //   onAfterPrint: () => {
  //     setView(false);
  //   },
  // });

  return (
    <>
      <Row justify="flex-start" gutter={[20, 20]}>
        <FdrInstitutionSelect span={6} />
        <SortTypeAndBy
          span={6}
          sortBy={sortBy}
          sortType={sortType}
          setSortBy={setSortBy}
          setSortType={setSortType}
        />{" "}
      </Row>
      <br />
      <Table
        className={" accomadation_table captalise-center mt-10 "}
        tableLayout="fixed"
        scroll={{ x: "max-content" }}
        loading={loading}
        columns={[
          {
            title: "S.no",
            key: "sno",
            width: 70,
            render: (text, object, index) => index + 1,
          },
          {
            title: "Institution Name",
            dataIndex: "institution",
            render: (record) => record.name,
          },

          {
            title: "Category",
            dataIndex: "accountCategoryName",
          },

          {
            title: "Actions",
            key: "status",
            render: (record) => {
              return (
                <Space size="middle">
                  <Popconfirm
                    title="Are you sure delete this account category?"
                    onConfirm={async () => {
                      await deleteCreatedAccountCategory(record.id, router);
                      setUpdate(Math.random() * 100000 + 21);
                    }}
                    okText="Yes"
                    cancelText="No"
                    loading={deleteLoading}
                  >
                    <DeleteOutlined />
                  </Popconfirm>
                </Space>
              );
            },
          },
        ].map((item) => {
          return { ...item, align: "center" };
        })}
        dataSource={accountCategoryData?.items ?? []}
        onChange={handleTableChange}
        pagination={{
          total: accountCategoryData?.meta?.totalItems ?? 0,
          current: tableCurrentPage,
          pageSize: tablePageSize,
        }}
      ></Table>
    </>
  );
};

export default withRouter(TmsSmFdrAccountList);
